import React from "react";
import { Col, Container, Row } from "react-bootstrap";

const Perks = () => {
  return (
    <div className="Perks p-100">
      <Container className="h-100">
        <Row className="h-100">
          <Col
            xs={12}
            md={10}
            lg={10}
            xl={10}
            xxl={10}
            className="m-auto text-center"
          >
            <h2>
              Benefits of Partnering With A Leading Healthcare Software
              Development Company
            </h2>
            <p>
              You can experience smooth development and outstanding results when
              partnering with a leading software development company. Here are
              the perks of seeking reliable software development services for
              healthcare.
            </p>
          </Col>
        </Row>
        <Row className="h-100 perks-padd">
          <Col xs={12} md={6} lg={6} xl={3} xxl={3} className="mb-lg-5 mb-xl-0">
            <div className="perks-box">
              <div className="perks-content">
                <h4>Utilizing Advanced Technologies</h4>
                <p>
                  We redefine the healthcare sector by using modern technologies
                  to ease patient care
                </p>
              </div>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={3} xxl={3} className="mb-lg-5 mb-xl-0">
            <div className="perks-box">
              <div className="perks-content">
                <h4>Reachable and flexible Options</h4>
                <p>
                  Achieve your healthcare goals with our adaptable approach to
                  software development, customized to the industry's demanding
                  requirements.
                </p>
              </div>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={3} xxl={3}>
            <div className="perks-box">
              <div className="perks-content">
                <h4>Transparency in the process</h4>
                <p>
                  We keep all the processes transparent to our clients at any
                  stage in the development cycle with our project management
                  tools.
                </p>
              </div>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={3} xxl={3}>
            <div className="perks-box">
              <div className="perks-content">
                <h4>Budget-Friendly Pricing Models</h4>
                <p>
                  Get an accurate estimation of the cost of your healthcare
                  software development project with our pricing model.
                </p>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Perks;
